import React from 'react';
import CampoTexto from '../Formulario/CampoTexto';
import CampoSeletor from '../Formulario/CampoSeletor';
import Grid, { GridItem } from '../layout/Grid';
import { CanalDto } from '@tera/shared/src/dto/CanalDto';
import VBox from '../layout/VBox';
import { FormCamposProps } from './canal/FormCamposProps';
import { FormCamposWhatsapp } from './canal/FormCamposWhatsapp';
import { FormCamposEmail } from './canal/FormCamposEmail';
import { FormCamposWebchat } from './canal/FormCamposWebchat';
import { FormCamposTelegram } from './canal/FormCamposTelegram';
import { FormCamposWa360 } from './canal/FormCamposWa360';
import { FormCamposInstagram } from './canal/FormCamposInstagram';
import { FormCamposVoip } from './canal/FormCamposVoip';

type FormCanalProps = {
  host?: string;
  value: CanalDto;
  onChange: (data: any) => void;
  fieldErrors: Record<string, string> | null;
};

const tipos: any[] = [
  { label: 'Whatsapp', id: 'whatsapp' },
  { label: 'Whatsapp (360D)', id: 'wa360' },
  { label: 'Telegram', id: 'telegram' },
  { label: 'E-mail', id: 'email' },
  { label: 'Webchat', id: 'webchat' },
  { label: 'Instagram', id: 'instagram' },
  { label: 'VoIP', id: 'voip' },
];

const camposPorTipo: Record<
  string,
  ({ value, onChange, fieldErrors }: FormCamposProps) => React.ReactElement
> = {
  whatsapp: ({ canalId, host, value, onChange, fieldErrors, props, onChangeProps }) => (
    <FormCamposWhatsapp
      canalId={canalId}
      host={host}
      value={value}
      onChange={onChange}
      fieldErrors={fieldErrors}
      props={props}
      onChangeProps={onChangeProps}
    />
  ),
  wa360: ({ host, value, onChange, fieldErrors }) => (
    <FormCamposWa360
      host={host}
      value={value}
      onChange={onChange}
      fieldErrors={fieldErrors}
    />
  ),
  telegram: ({ host, value, onChange, fieldErrors }) => (
    <FormCamposTelegram
      host={host}
      value={value}
      onChange={onChange}
      fieldErrors={fieldErrors}
    />
  ),
  email: ({ host, value, onChange, fieldErrors }) => (
    <FormCamposEmail
      host={host}
      value={value}
      onChange={onChange}
      fieldErrors={fieldErrors}
    />
  ),
  webchat: ({ host, value, onChange, fieldErrors }) => (
    <FormCamposWebchat
      host={host}
      value={value}
      onChange={onChange}
      fieldErrors={fieldErrors}
    />
  ),
  instagram: ({ host, value, onChange, fieldErrors }) => (
    <FormCamposInstagram
      host={host}
      value={value}
      onChange={onChange}
      fieldErrors={fieldErrors}
    />
  ),
  voip: ({ canalId, host, value, onChange, fieldErrors, props, onChangeProps }) => (
    <FormCamposVoip
      canalId={canalId}
      host={host}
      value={value}
      onChange={onChange}
      fieldErrors={fieldErrors}
      props={props}
      onChangeProps={onChangeProps}
    />
  ),
};

type CamposFormProps = {
  tipo?: string;
} & FormCamposProps;

const CamposForm = ({
  canalId,
  tipo,
  host,
  value,
  onChange,
  fieldErrors,
  props,
  onChangeProps,
}: CamposFormProps) => {
  return tipo && camposPorTipo[tipo] ? (
    camposPorTipo[tipo]({ canalId, host, value, onChange, fieldErrors, props, onChangeProps })
  ) : (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '48px',
        border: '1px solid var(--tc-color-gray-100)',
        backgroundColor: 'var(--tc-color-gray-200)',
      }}
    >
      Selecione um tipo para continuar
    </div>
  );
};

const FormCanal = ({ host, value, onChange, fieldErrors }: FormCanalProps) => {
  const editMode = !!value?.id && value.id > 0;

  return (
    <VBox gap="8px">
      <Grid>
        <GridItem sm={12} md={2}>
          <CampoTexto
            disabled
            readOnly
            label="Código"
            type="text"
            name="id"
            defaultValue={value?.id ?? '(Novo)'}
            autoFill="do-not-autofill-please"
          />
        </GridItem>
        <GridItem sm={12} md={4}>
          <CampoSeletor
            disabled={editMode}
            label="Tipo"
            name="tipo"
            options={tipos}
            value={value?.tipo}
            onChange={v => onChange({ ...value, tipo: v })}
            autoFill="do-not-autofill-please"
            error={fieldErrors?.[`tipo`]}
          />
        </GridItem>
        <GridItem sm={12} md={6}>
          <CampoTexto
            label="Nome"
            type="text"
            name="nome"
            value={value?.nome ?? ''}
            onChange={v => onChange({ ...value, nome: v })}
            autoFill="do-not-autofill-please"
            error={fieldErrors?.[`nome`]}
          />
        </GridItem>
      </Grid>
      <input
        type="text"
        name="username"
        style={{
          position: 'absolute',
          height: 0,
          border: 'none',
          outline: 'none',
          opacity: 0,
        }}
      />
      <input
        type="password"
        name="password"
        style={{
          position: 'absolute',
          height: 0,
          border: 'none',
          outline: 'none',
          opacity: 0,
        }}
      />
      <CamposForm
        canalId={+value?.id}
        tipo={value?.tipo}
        host={host}
        value={value?.chave_api}
        onChange={v => onChange({ ...value, chave_api: v })}
        fieldErrors={fieldErrors}
        props={value?.propriedades || {}}
        onChangeProps={props => onChange({ ...value, propriedades: props })}
      />
    </VBox>
  );
};

export default FormCanal;
